module.exports = __webpack_public_path__ + "static/media/imgop_ComicImage.f12e7871.webp";